import { useQuery } from "react-query";
import { storeLocalData, getLocalData } from "../services/storage";
import useNetworkHealth from "./useNetworkHealth";
import openhouseAPI from "../services/openhouse";

const normalizeAnswers = (payload: any) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export const useGetQuestionAnswers = (uuid: string) => {
  const network = useNetworkHealth();
  const { isFetching, isFetched, data, error, refetch } = useQuery(
    ["formQuestionAnswers", uuid],
    async () => {
      if (!uuid) {
        return [];
      }

      const localAnswers = await getLocalData(`@formQuestionAnswers+${uuid}`);
      const normalizedLocalAnswers = normalizeAnswers(localAnswers);

      if (normalizedLocalAnswers.length > 0) {
        return normalizedLocalAnswers;
      }

      if (network.isOffline) {
        return normalizedLocalAnswers;
      }

      try {
        const res = await openhouseAPI.get(`/form/question/answers/${uuid}`);
        const normalizedAnswers = normalizeAnswers(res.data);
        await storeLocalData(`@formQuestionAnswers+${uuid}`, normalizedAnswers);
        return normalizedAnswers;
      } catch (error) {
        console.error("Error fetching question answers:", error);
        return normalizedLocalAnswers;
      }
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: true,
    }
  );

  return {
    isFetching,
    isFetched,
    data,
    error,
    refetch,
  };
};
